import { Dispatch } from 'redux';

import { IS_PREVIEW, MAX_BLOG_ENTRIES_PER_PAGE } from '@src/typescriptGlobals/constants';

import { GQL_FETCH_LATEST_BLOG_ENTRIES, GQL_FETCH_NEWS_AND_RESEARCH_PAGE_ENTRIES } from '@src/graphql/queries';

import { store } from '@src/redux/store/store';

import fetchAPI from '@src/utils/fetchAPI';

import {
  ILatestNewsDataActionType,
  ILoadingActionType,
  INewsDataActionType,
  LoadingParamsType,
  NewsParamsType,
} from './newsActions.types';
import { ActionTypes } from '..';

export const toggleLoadingAXN = ({ isLoading }: LoadingParamsType): ILoadingActionType => {
  return {
    type: ActionTypes.NEWS_TOGGLE_LOADING,
    payload: isLoading,
  };
};

export const fetchLatestAndNewsDataAXN =
  ({ categorySlug = null, skip = 0, locale }: NewsParamsType) =>
  async (dispatch: Dispatch<INewsDataActionType | ILatestNewsDataActionType>) => {
    store.dispatch(toggleLoadingAXN({ isLoading: true }));

    try {
      const latestNewsResponse = await fetchAPI<any>({
        query: GQL_FETCH_LATEST_BLOG_ENTRIES?.loc?.source?.body ?? '',
        variables: {
          locale: locale?.toUpperCase(),
          preview: IS_PREVIEW,
        },
      });

      const newsDataResponse = await fetchAPI<any>({
        query: GQL_FETCH_NEWS_AND_RESEARCH_PAGE_ENTRIES?.loc?.source?.body ?? '',
        variables: {
          skip,
          limit: MAX_BLOG_ENTRIES_PER_PAGE,
          excludeId: latestNewsResponse?.latestBlog?.items?.[0]?.sys?.id,
          categorySlug: categorySlug,
          locale: locale?.toUpperCase(),
          preview: IS_PREVIEW,
        },
      });

      dispatch({
        type: ActionTypes.FETCH_LATEST_NEWS_DATA,
        payload: latestNewsResponse?.latestBlog?.items?.[0],
      });

      dispatch({
        type: ActionTypes.FETCH_NEWS_DATA,
        payload: newsDataResponse,
      });
      store.dispatch(toggleLoadingAXN({ isLoading: false }));
    } catch (error) {
      // Optionally, dispatch another action to handle errors
      // dispatch({
      //   type: ActionTypes.FETCH_NEWS_DATA_ERROR,
      //   payload: error,
      // });
      store.dispatch(toggleLoadingAXN({ isLoading: false }));
    }
  };

export const fetchNewsDataAXN =
  ({ categorySlug = null, skip = 0, locale }: NewsParamsType) =>
  async (dispatch: Dispatch<INewsDataActionType>) => {
    store.dispatch(toggleLoadingAXN({ isLoading: true }));

    try {
      const { latestNewsData } = store.getState().newsRXS;

      const newsDataResponse = await fetchAPI<any>({
        query: GQL_FETCH_NEWS_AND_RESEARCH_PAGE_ENTRIES?.loc?.source?.body ?? '',
        variables: {
          skip,
          limit: MAX_BLOG_ENTRIES_PER_PAGE,
          excludeId: latestNewsData?.sys?.id,
          categorySlug: categorySlug,
          locale: locale?.toUpperCase(),
          preview: IS_PREVIEW,
        },
      });

      dispatch({
        type: ActionTypes.FETCH_NEWS_DATA,
        payload: newsDataResponse,
      });
      store.dispatch(toggleLoadingAXN({ isLoading: false }));
    } catch (error) {
      // Optionally, dispatch another action to handle errors
      // dispatch({
      //   type: ActionTypes.FETCH_NEWS_DATA_ERROR,
      //   payload: error,
      // });
      store.dispatch(toggleLoadingAXN({ isLoading: false }));
    }
  };
